<template>
  <div>
    <div>
      <div class="row rowgap">
        <div class="col-md-12">
            <p class="title-content">
                Student Information
            </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="padding-bottom: 15px;">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                  <label>Student Name</label><span class="validation-star">*</span>
                  <ob-input v-model.trim="StudentDetails.Name" placeholder="Enter Student Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.Name.$error }"></ob-input>
                  <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.required"> Enter name</span>
                  <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.maxLength && $v.StudentDetails.Name.alpha"> Enter 150 characters only</span>
                  <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty &&  $v.StudentDetails.Name.alpha && !$v.StudentDetails.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                  <label>Student Email Address</label><span class="validation-star">*</span>
                  <ob-input v-model.trim="StudentDetails.EmailAddress" placeholder="Enter Student Email Address" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.EmailAddress.$error }"></ob-input>
                  <template v-if="$v.StudentDetails.EmailAddress.$dirty">
                          <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.EmailAddress.required">Enter Student Email</span>
                          <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.EmailAddress.email">Enter valid email</span>
                  </template>
              </div>
            </div>
            <div class="col-md-4">
                <div class="form-group" style="padding-left :17px;">
                    <label>Signatory Authority</label> <i class="fa fa-info-circle" v-tooltip="'HR Manager can add Signatory Authority '"></i>
                    <ob-select2 v-if="showSignatoryauthorityList" :options="signatoryauthorityList" v-model.trim="selectedSignatoryAuthorityEmail"></ob-select2>
                </div>
            </div>
          </div>
          <div class="row" v-if ="EmployerDetails.Signatoryauthority.Name != '' && EmployerDetails.Signatoryauthority.Email != ''">
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Signatory Authority Name</label>
                      <b><p>{{EmployerDetails.Signatoryauthority.Name}}</p></b>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form-group">
                      <label>Signatory Authority Email</label>
                      <b><p> {{EmployerDetails.Signatoryauthority.Email}}</p></b>
                  </div>
              </div>
          </div>
          <div class="row rowgap">
            <div class="col-md-12">
                <p class="title-content">
                    Evaluation Information
                </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Range of Evaluation Date(From)</label><span class="validation-star">*</span>
                <ob-date-time-picker ref="dateFrom" id="dateFrom" :inputvalue="StudentDetails.RangeOfEvaluationDateFrom" :options="options4" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateFrom = v" :dpchange="onFromDateChange" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.RangeOfEvaluationDateFrom.$error }"></ob-date-time-picker>
                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.RangeOfEvaluationDateFrom.$dirty && !$v.StudentDetails.RangeOfEvaluationDateFrom.required"> Enter Range Of Evaluation Date From</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Range of Evaluation Date(To)</label><span class="validation-star">*</span>
                <ob-date-time-picker ref="dateTo" id="dateTo" :inputvalue="StudentDetails.RangeOfEvaluationDateTo" :options="options4" @updated="(v) => this.StudentDetails.RangeOfEvaluationDateTo = v" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.RangeOfEvaluationDateTo.$error }"></ob-date-time-picker>
                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.RangeOfEvaluationDateTo.$dirty && !$v.StudentDetails.RangeOfEvaluationDateTo.required"> Enter Range Of Evaluation Date To</span>
              </div>
            </div>
          </div>

          <div class="row" v-if="isupdate || !isHRManager">
            <div class="col-md-12">
              <div class="form-group">
                <label>Evaluation Summary</label><span v-on:mouseover="mouseOver = '1'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '1' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter your full name (Surname/Primary Name, Given Name) exactly as it appears on your SEVIS (Student and Exchange Visitor Information System) issued Form I‐20, “Certificate of Eligibility for Nonimmigrant (F‐1) Student Status – For Academic and Language Students."'/></span>
                <ob-textarea v-model="StudentDetails.EvaluationSummary"></ob-textarea>
              </div>
            </div>
          </div>

          <div class="row rowgap" style="padding-left:15px">
            <div class="checkbox-inline" style="padding: 0; margin-right: 5px;"><ob-checkbox :disabled="IsFinalEvaluationDone" v-model="StudentDetails.isFinalEvalution">Mark this as a final Evaluation</ob-checkbox></div><i style="vertical-align: middle;" class="fa fa-info-circle" v-if="IsFinalEvaluationDone" v-tooltip="'Final Evaluation is already done. Please update the current final evaluation to enable this checkbox.'"></i>
          </div>

          <div class="row rowgap" style="padding-left:15px" v-if="isHRManager">
            An Email will be sent to the student with the above information.
          </div>
          <div class="row rowgap" style="padding-left:15px" v-else>
            An Email will be sent to the HR Manager with the above information.
          </div>
          <div class="row rowgap"  style="border-top: 1.5px dashed #d4cccc;margin-top: 15px; padding-top: 15px;">
             <b class="col-md-12" style="padding-bottom:15px">Choose your preferred option to initiate Student Evaluation<span class="validation-star">*</span></b>
             <div class="col-md-6">
                <ob-radio name="I983FormType"  :val="false" v-model="IsInitiateOnlySectionType"><b>Initiate New Form I-983</b></ob-radio>
                <p style="padding-left: 20px;">Creates a new Form I-983 by auto-populating all the data from the existing one.</p>
             </div>
              <div class="col-md-6">
                <ob-radio name="I983FormType"  :val="true" v-model="IsInitiateOnlySectionType"><b>Initiate Student Evaluation Only</b></ob-radio>
                <p style="padding-left: 20px;">Creates only Student Evaluation section</p>
                    </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <ob-button type="secondary" @click="show = false">Cancel</ob-button>
      <ob-button type="primary" @click="onInitiateClick">{{ isupdate ? 'Update' : triggerupdateapi ? 'Preview Form' : 'Initiate' }}</ob-button>
    </div>
  </div>
</template>
<script>
  import {
    required, minLength, maxLength, requiredIf, email, alpha, minValue
  }
  from 'vuelidate/lib/validators'
  import {
    req, withParams
  }
  from 'vuelidate/lib/validators/common'
  const DecimalNumber = withParams({
    type: 'DecimalNumber'
  }, value => {
    return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
  })
  const alphawithspace = (value) => {
    var alsp = /^[a-zA-Z\s]*$/i
    return alsp.test(value)
  }
  const letterCount = withParams({
    type: 'letterCount'
  }, value => {
    if (value != null && value.length <= 150) {
      var strArr = value.split(" ");
      let error = true;
      strArr.forEach(function(word) {
        if (word.length > 100) {
          error = false
          return;
        }
      });
      return !req(value) || error
    } else {
      return true
    }

  })


  export default {
    props: ["openModal", "previousData", "isupdate", "triggerupdateapi"],
    data() {
      return {
        IsInitiateOnlySectionType:false,
        show: false,
        mouseOver:'',
        EvalutionObj: '',
        StudentDetails: {
          EmployeeId: '',
          Name: '',
          EmailAddress: '',
          RangeOfEvaluationDateFrom: '',
          RangeOfEvaluationDateTo: '',
          isFinalEvalution: false,
          EvaluationSummary: ''
        },
        options4: {
          format: 'MM/DD/YYYY',
          dayViewHeaderFormat: 'MM/DD/YYYY',
          ignoreReadonly: true,
          widgetPositioning: {
            horizontal: "auto",
            vertical: "bottom"
          }
        },
        showSignatoryauthorityList:false,
        selectedSignatoryAuthorityEmail:'',
        EmployerDetails: {
          Signatoryauthority : {
            Name: '',
            Email:''
          }
        },
        signatoryauthorityList: {
            placeholder: {
                id: "-1",
                text: "Select Signatory Authority"
            },
            data: []
        },
      }
    },
    watch: {
      openModal(val) {
          this.show = val;
          if (val) { // On Modal Open

            this.copyFromStore();
          }
        },
        show(val) {
          this.$emit('update:openModal', val)
        },
        selectedSignatoryAuthorityEmail(v) {
          this.onChangeSignatoryAuthority(v);
        }
    },
    computed: {
      EmployeeId() {
        return this.$parent.$parent.EmployeeId;
      },
      StudentName() {
        return this.$parent.$parent.StudentName;
      },
      IsFinalEvaluationDone() {
        return this.$parent.$parent.IsFinalEvaluationDone;
      }
    },
    created() {
      this.show = this.openModal;
      this.copyFromStore();
    },
    validations() {
      return {
        StudentDetails: {
          "Name":
          {
            required,
            maxLength: maxLength(150),
            letterCount
          },
          "EmailAddress":
          {
            required,
            email
          },
          "RangeOfEvaluationDateFrom": {
            required
          },
          "RangeOfEvaluationDateTo": {
            required
          }
        },
      }
    },
    methods: {
      copyFromStore() {
        // Reset the Form Data
        this.resetData();

        // Pre-populate the data
        this.StudentDetails.Name = this.previousData.StudentName;
        this.StudentDetails.EmailAddress = this.previousData.StudentEmail;

        // Get Signatory Authority List
        this.getSignatoryauthorityList();
      },
      resetData() {
        this.StudentDetails = {
          EmployeeId: '',
          Name: '',
          EmailAddress: '',
          RangeOfEvaluationDateFrom: '',
          RangeOfEvaluationDateTo: '',
          isFinalEvalution: false,
          EvaluationSummary: ''
        };

        this.EmployerDetails = {
          Signatoryauthority: {
            Name: '',
            Email: ''
          },
        };

      },
      onChangeSignatoryAuthority(selectedSignatoryAuthorityEmail){
        if(selectedSignatoryAuthorityEmail) {
              var index = this.signatoryauthorityList.data.findIndex(x => x.id == selectedSignatoryAuthorityEmail);
              this.EmployerDetails.Signatoryauthority.Name = this.signatoryauthorityList.data[index].text
              this.EmployerDetails.Signatoryauthority.Email = this.signatoryauthorityList.data[index].id
        }
      },
      getSignatoryauthorityList() {   this.showSignatoryauthorityList = false
        ajax.get(`/I983/SignatoryList?employeeId=${empId}`,{},(res)=>{
            this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
              var name = t.BasicModel.Name;
                        if(t.Email == this.loggedInUserObj.email)
                        {
                          name = t.BasicModel.Name + " (you)";
                        }
                return { 'id': t.Email, 'text': name,"SAId":t.Id }
            })
            this.showSignatoryauthorityList = true
        })
      },
        onFromDateChange(e) {
          this.$refs.dateTo.data.minDate(e.date)
        },
        onInitiateClick() {

          this.$v.StudentDetails.$touch();

          if (this.$v.StudentDetails.$invalid == false) {
            var evaluation = {
              EvaluationFrom: this.StudentDetails.RangeOfEvaluationDateFrom,
              EvaluationTo: this.StudentDetails.RangeOfEvaluationDateTo,
              EvaluationSummary: this.StudentDetails.EvaluationSummary,
              IsFinalEvalution: this.StudentDetails.isFinalEvalution
            }
            var employee = {
              EmployeeId: !this.$parent.$parent.isSupervisor ? this.EmployeeId : this.$parent.$parent.EmployeeId
            }

            var signatoryAuthority = {
              Name:this.EmployerDetails.Signatoryauthority.Name && this.EmployerDetails.Signatoryauthority.Name.includes("you") ? this.EmployerDetails.Signatoryauthority.Name.replace("you", "").trim() : this.EmployerDetails.Signatoryauthority.Name,
              Email:this.EmployerDetails.Signatoryauthority.Email,
            }

            let employerInfo = {
              SignatoryAuthority:signatoryAuthority
            }

            this.EvalutionObj = {
              Employer:employerInfo,
              Evaluation: evaluation,
              Employee: employee,
              Type: "Evaluation",
              IsInitiateOnlySectionType:this.IsInitiateOnlySectionType
            }

            this.makeInitiateAPICall();
          }
        },
        makeInitiateAPICall() {
          this.$loading({
            'loadingText': 'Initiating Student Evaluation...'
          });
          ajax.post(`/I983/Initiate?empOrgId=${loggedInUserObj.orgId}`, this.EvalutionObj, (res) => {
            if (res.data.State == true) {
              this.$message({
                type: 'success',
                message: 'Student Evaluation initiated successfully'
              });
              this.$loading({}).close()
              this.show = false;
              this.$emit('initiated');
            } else if (res.data.State == false) {
              this.$loading({}).close()
              this.show = false
              this.ESSEnableDisable(res)
              this.$message({
                type: 'error',
                message: res.data.Message
              });
            }
          });
        },
    }
  }
</script>
<style lang="scss" scoped>
  .title-content {
    color: #4a90e2;
    font-size: 14px;
    padding-left: 0;
    margin-bottom: 10px;
  }

  .rowgap {
    margin-top: 10px;
  }

  .validation-star {
    color: #F31D1D;
  }

  .radio-inline {
    padding-left: 0px
  }

  label {
    color: #a4abb9
  }

  .preview-details {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateFlow/InitiateStudentEvalution.vue